// Steps/FilterSection.js - Step 2 Component
import React, { useContext, useState, useEffect, useCallback } from 'react';
import { Box, Typography, Grid, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, TextField, Autocomplete, Chip, MenuItem, Select, InputLabel, Checkbox, Paper, Divider, Alert, CircularProgress, Card, CardContent, debounce } from '@mui/material';
import { LocationOn, People, Engineering } from '@mui/icons-material';
import { NotificationDataContext } from '../AddEditNotification';
import { CustomerService } from '../../../Customer/Service';
import AudienceFilter from './AudienceFilter';
import { NotificationServices } from '../NotificationServices';
import { CrudServices } from '../../../MasterService/CrudServices';
import { set } from 'zod';

const FilterSection = () => {
    const { notificationData, setNotificationData } = useContext(NotificationDataContext);
    
    const [isLoadingCustomers, setIsLoadingCustomers] = useState(false);
    const [isLoadingExperts, setIsLoadingExperts] = useState(false);
    const [customerList, setCustomerList] = useState([]);
    const [expertList, setExpertList] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    
    const [filters, setFilters] = useState([]);
    const [clearMultiFilter, setClearMultiFilter] = useState(false);
    // const [filterCache, setFilterCache] = useState(new Map());
    // const [isDebouncing, setIsDebouncing] = useState(false);

    // // Debounced filter function
    // const debouncedFetch = useCallback(
    //     debounce(async (filters) => {
    //     const cacheKey = JSON.stringify(filters);
        
    //     // Check cache first
    //     if (filterCache.has(cacheKey)) {
    //     const cachedData = filterCache.get(cacheKey);
    //     setCustomerList(cachedData.customers);
    //     setIsDebouncing(false);
    //     return;
    //     }

    //     setIsLoadingCustomers(true);
    //     try {
    //     const response = await NotificationServices.fetchCustomers(filters, 'complete');
    //     if (response.success === 1) {
    //         setCustomerList(response.data.customers);
            
    //         // Cache the result
    //         setFilterCache(prev => {
    //         const newCache = new Map(prev);
    //         newCache.set(cacheKey, response.data);
    //         return newCache;
    //         });
    //     }
    //     } catch (error) {
    //     console.error('Error fetching customers:', error);
    //     } finally {
    //     setIsLoadingCustomers(false);
    //     setIsDebouncing(false);
    //     }
    // }, 300),[filterCache]);
    
    const [cityList, setCityList] = useState([]);
    const [stateList, setStateList] = useState([]);
    const fetchStateCityLists = async ()=>{
        let cities = [];
        let states = [];
        if (notificationData.audienceType === 'customer') {
            const customerAddresses = await NotificationServices.fetchCustomersAddress();
            if (customerAddresses.success == '1') {
                cities = customerAddresses.data.cities;
                states = customerAddresses.data.states;
            }
        } else if (notificationData.audienceType === 'expert') {
            const expertAddresses = await NotificationServices.fetchExpertsAddress();
            if (expertAddresses.success == '1') {
                cities = expertAddresses.data.cities;
                states = expertAddresses.data.states;
            }
        }
        setCityList(cities);
        setStateList(states);
    }
    useEffect(() => {
        fetchStateCityLists();
    }, [notificationData.audienceType]);

    useEffect(() => {
        if (notificationData.audienceType === 'customer') {
            fetchCustomerList();
        } else if (notificationData.audienceType === 'expert') {
            fetchExpertList();
        }
    }, [notificationData.audienceType, notificationData.customerFilters.filterOptions, notificationData.expertFilters.filterOptions]);

    // Fetch customer list
    const fetchCustomerList = async () => {
        console.log("notification data:", notificationData.customerFilters);
        setIsLoadingCustomers(true);
        try {
            const response = await NotificationServices.fetchAllFilteredCustomers(notificationData.customerFilters,'complete');
            console.log("customer list response:", response);
            if (response.success == '1') {
                setCustomerList(response.data.customers);
                // setFilteredData(response.data.customers);
            }else if(response.success == '0'){
                setCustomerList([]);
            }
        } catch (error) {
            console.error('Error fetching customers:', error);
        } finally {
            setIsLoadingCustomers(false);
        }
    };

    // Mock fetch expert list
    const fetchExpertList = async () => {
        setIsLoadingExperts(true);
        // console.log("notification data:", notificationData.expertFilters);
        setIsLoadingExperts(true);
        try {
            const response = await NotificationServices.fetchAllFilteredExperts(notificationData.expertFilters,'complete');
            console.log("expert list response:", response);
            if (response.success == '1') {
                setExpertList(response.data.experts);
                // setFilteredData(response.data.customers);
            }else if(response.success == '0'){
                setExpertList([]);
            }
        } catch (error) {
            console.error('Error fetching experts:', error);
        } finally {
            setIsLoadingExperts(false);
        }
    };

    const getFullName = (profile) => {
        if (!profile) return '';
        return [profile.firstName, profile.middleName, profile.lastName]
            .filter(Boolean)
            .join(' ');
    };

    // Apply filters from AudienceFilter
    // const handleApplyFilter = (filterData) => {
    //     console.log('Applied Filters:', filterData);
        
    //     // Update notification data with selected items
    //     if (notificationData.audienceType === 'customer') {
    //         setNotificationData(prev => ({
    //             ...prev,
    //             customerFilters: {
    //                 ...prev.customerFilters,
    //                 filterOptions: filterData.filterOption,
    //             }
    //         }));
    //     } else {
    //         setNotificationData(prev => ({
    //             ...prev,
    //             expertFilters: {
    //                 ...prev.expertFilters,
    //                 filterOptions: filterData.filterOptions,
    //             }
    //         }));
    //     }
    // };
    const handleApplyFilter = async(filterData) => {
        console.log('Applied Filters:', filterData);
        // setIsDebouncing(true);
        
        if (notificationData.audienceType === 'customer') {
            setNotificationData(prev => ({
                ...prev,
                customerFilters: {
                    ...prev.customerFilters,
                    selectedCustomers: [],
                    filterOptions: filterData.filterOption,
                    locationFilters: filterData.locationFilters
                }
            }));
            
            // Trigger debounced fetch
            // debouncedFetch({
            //     ...notificationData.customerFilters,
            //     filterOptions: filterData.filterOption,
            //     locationFilters: filterData.locationFilters
            // });
            setIsLoadingCustomers(true);
            try {
            const response = await NotificationServices.fetchCustomers(filters, 'complete');
            if (response.success === 1) {
                setCustomerList(response.data.customers);
                
                // Cache the result
                // setFilterCache(prev => {
                // const newCache = new Map(prev);
                // newCache.set(cacheKey, response.data);
                // return newCache;
                // });
            }else if(response.success === 0){
                setCustomerList([]);
            }
            } catch (error) {
            console.error('Error fetching customers:', error);
            }finally{
                setIsLoadingCustomers(false);
            }
        }else if (notificationData.audienceType === 'expert') {
            setNotificationData(prev => ({
                ...prev,
                expertFilters: {
                    ...prev.expertFilters,
                    selectedExperts: [],
                    filterOptions: filterData.filterOption,
                    locationFilters: filterData.locationFilters
                }
            }));
            console.log("expert filter data:",filterData);
        }
    };
    const clearFilters = () => {
        setFilters({
            sortKey: 'createdAt',
            sortDirection: 'desc',
            filterOptions: []
        });
        
        setClearMultiFilter(true);
        setTimeout(() => setClearMultiFilter(false), 100);
    };
    
    const [categoryList, setCategoryList] = useState([]);
    useEffect(()=>{
        const fetchCategoryList= async()=>{
            try {
                const categoryListResponse = await CrudServices.categoryList();
                console.log("category list Response:",categoryListResponse);
                if(categoryListResponse.success===1){
                setCategoryList(categoryListResponse.data)
                }
            } catch (error) {
                
            }
        }
        fetchCategoryList();
    },[]);
    // Define filterable columns based on audience type
    const getFilterableColumns = () => {
    if (notificationData.audienceType === 'customer') {
        return [
            // Basic Info
            // {
            //     key: 'name',
            //     label: 'Customer Name',
            //     type: 'text'
            // },
            {
                key: 'mobileNumber',
                label: 'Mobile Number',
                type: 'number'
            },
            // {
            //     key: 'email',
            //     label: 'Email',
            //     type: 'email'
            // },
            
            // Gender - Multi Select
            {
                key: 'gender',
                label: 'Gender',
                type: 'multiselect',
                options: [
                    { value: 'Male', label: 'Male' },
                    { value: 'Female', label: 'Female' },
                    { value: 'Prefer Not To Say', label: 'Prefer Not To Say' }
                ]
            },
            
            // Activity Based Filters
            {
                key: 'lastActive',
                label: 'Last Active',
                type: 'select',
                options: [
                    { value: '7', label: 'Within 7 Days' },
                    { value: '30', label: 'Within 30 Days' },
                    { value: '90', label: 'Within 90 Days' }
                ]
            },
            {
                key: 'lastInactive',
                label: 'Inactive For Days',
                type: 'number',
                placeholder: 'Enter number of days'
            },
            
            // Age Range
            {
                key: 'ageRange',
                label: 'Age Range',
                type: 'range',
                min: 13,
                max: 100,
                defaultValue: [18, 65],
                marks: [
                    { value: 18, label: '18' },
                    { value: 30, label: '30' },
                    { value: 50, label: '50' },
                    { value: 70, label: '70' }
                ]
            },
            
            // Location Filters
            {
                key: 'city',
                label: 'City',
                type: 'multiselect',
                options: cityList.map(city=>({value:city,label:city}))
                // [
                //     { value: 'mumbai', label: 'Mumbai' },
                //     { value: 'delhi', label: 'Delhi' },
                //     { value: 'bangalore', label: 'Bangalore' },
                //     { value: 'pune', label: 'Pune' },
                //     { value: 'hyderabad', label: 'Hyderabad' },
                //     { value: 'chennai', label: 'Chennai' },
                //     { value: 'kolkata', label: 'Kolkata' },
                //     { value: 'ahmedabad', label: 'Ahmedabad' },
                //     { value: 'jaipur', label: 'Jaipur' },
                //     { value: 'lucknow', label: 'Lucknow' }
                //     // Add more cities as needed
                // ]
            },
            {
                key: 'state',
                label: 'State',
                type: 'multiselect',
                options: stateList.map(state=>({value:state,label:state})), 
                // [
                //     { value: 'Maharashtra', label: 'Maharashtra' },
                //     { value: 'Delhi', label: 'Delhi' },
                //     { value: 'Karnataka', label: 'Karnataka' },
                //     { value: 'Tamil nadu', label: 'Tamil Nadu' },
                //     { value: 'West bengal', label: 'West Bengal' },
                //     { value: 'Gujarat', label: 'Gujarat' },
                //     { value: 'Rajasthan', label: 'Rajasthan' },
                //     { value: 'Uttar pradesh', label: 'Uttar Pradesh' },
                //     { value: 'Telangana', label: 'Telangana' },
                //     { value: 'Andhra pradesh', label: 'Andhra Pradesh' }
                //     // Add more states as needed
                // ]
            },
            {
                key: 'pincode',
                label: 'Pincode',
                type: 'number',
                placeholder: 'Enter pincode'
            },
            
            // Order Based Filters
            {
                key: 'noOrdersSince',
                label: 'No Orders Since',
                type: 'select',
                options: [
                    { value: '30', label: 'Last 30 Days' },
                    { value: '90', label: 'Last 90 Days' },
                    { value: '120', label: 'Last 120 Days' },
                    { value: '180', label: 'Last 180 Days' }
                ]
            },
            
            // Category Filters
            {
                key: 'orderCategory',
                label: 'Ordered Category',
                type: 'multiselect',
                options: categoryList.map(cat=>({value:cat.id,label:cat.title}))
            },
        ];
    } else {
        // Expert filters
        return [
            // Basic Info
            // {
            //     key: 'providerName',
            //     label: 'Expert Name',
            //     type: 'text'
            // },
            // {
            //     key: 'add_mobileNumber',
            //     label: 'Mobile Number',
            //     type: 'number'
            // },
            // {
            //     key: 'email',
            //     label: 'Email',
            //     type: 'email'
            // },
            
            // Specialty
            // {
            //     key: 'specialty',
            //     label: 'Specialty',
            //     type: 'multiselect',
            //     options: [
            //         { value: 'cardiology', label: 'Cardiology' },
            //         { value: 'dermatology', label: 'Dermatology' },
            //         { value: 'neurology', label: 'Neurology' },
            //         { value: 'pediatrics', label: 'Pediatrics' },
            //         { value: 'orthopedics', label: 'Orthopedics' },
            //         { value: 'gynecology', label: 'Gynecology' },
            //         { value: 'psychiatry', label: 'Psychiatry' },
            //         { value: 'dentistry', label: 'Dentistry' }
            //         // Add more specialties as needed
            //     ]
            // },
            
            // Activity Based
            {
                key: 'lastActive',
                label: 'Last Active',
                type: 'select',
                options: [
                    { value: '7', label: 'Within 7 Days' },
                    { value: '30', label: 'Within 30 Days' },
                    { value: '90', label: 'Within 90 Days' }
                ]
            },
            
            // Age Range
            {
                key: 'ageRange',
                label: 'Age Range',
                type: 'range',
                min: 13,
                max: 100,
                defaultValue: [18, 65],
                marks: [
                    { value: 18, label: '18' },
                    { value: 30, label: '30' },
                    { value: 50, label: '50' },
                    { value: 70, label: '70' }
                ]
            },
            
            // Gender
            {
                key: 'gender',
                label: 'Gender',
                type: 'multiselect',
                options: [
                    { value: 'Male', label: 'Male' },
                    { value: 'Female', label: 'Female' },
                    { value: 'Prefer Not To Say', label: 'Prefer Not To Say' }
                ]
            },
            
            // Location Filters
            {
                key: 'city',
                label: 'City',
                type: 'multiselect',
                options: cityList.map(city=>({value:city,label:city}))
                // [
                //     { value: 'mumbai', label: 'Mumbai' },
                //     { value: 'delhi', label: 'Delhi' },
                //     { value: 'bangalore', label: 'Bangalore' },
                //     { value: 'pune', label: 'Pune' },
                //     { value: 'hyderabad', label: 'Hyderabad' },
                //     { value: 'chennai', label: 'Chennai' },
                //     { value: 'kolkata', label: 'Kolkata' },
                //     { value: 'ahmedabad', label: 'Ahmedabad' },
                //     { value: 'jaipur', label: 'Jaipur' },
                //     { value: 'lucknow', label: 'Lucknow' }
                //     // Add more cities as needed
                // ]
            },
            {
                key: 'state',
                label: 'State',
                type: 'multiselect',
                options: stateList.map(state=>({value:state,label:state})), 
                // [
                //     { value: 'Maharashtra', label: 'Maharashtra' },
                //     { value: 'Delhi', label: 'Delhi' },
                //     { value: 'Karnataka', label: 'Karnataka' },
                //     { value: 'Tamil nadu', label: 'Tamil Nadu' },
                //     { value: 'West bengal', label: 'West Bengal' },
                //     { value: 'Gujarat', label: 'Gujarat' },
                //     { value: 'Rajasthan', label: 'Rajasthan' },
                //     { value: 'Uttar pradesh', label: 'Uttar Pradesh' },
                //     { value: 'Telangana', label: 'Telangana' },
                //     { value: 'Andhra pradesh', label: 'Andhra Pradesh' }
                //     // Add more states as needed
                // ]
            },
            {
                key: 'pincode',
                label: 'Pincode',
                type: 'number',
                placeholder: 'Enter pincode'
            },
            
            // Service Status
            // {
            //     key: 'status',
            //     label: 'Status',
            //     type: 'select',
            //     options: [
            //         { value: 'active', label: 'Active' },
            //         { value: 'inactive', label: 'Inactive' }
            //     ]
            // },
            
            // Booking Based Filters
            {
                key: 'bookingsReceivedInDays',
                label: 'Bookings Received in Last X Days',
                type: 'number',
                placeholder: 'Enter number of days'
            },
            {
                key: 'noBookingsSince',
                label: 'No Bookings Since Days',
                type: 'number',
                placeholder: 'Days without bookings'
            },
        ];
    }
    };

    if (!notificationData.audienceType) {
        return (
            <Alert severity="warning" sx={{ mt: 2 }}>
                Please select an audience type first.
            </Alert>
        );
    }

    return (
        <Box>
            {/* Enhanced AudienceFilter with geo filtering */}
            <Box sx={{ mb: 3,display:'flex',alignItems:'center',justifyContent:'space-between' }}>
                <AudienceFilter
                    filterableColumns={getFilterableColumns()}
                    defaultFilterOptions= {notificationData.audienceType === 'customer' ? notificationData.customerFilters.filterOptions : notificationData.expertFilters.filterOptions}
                    onApplyFilter={handleApplyFilter}
                    externalClear={clearMultiFilter}
                    // enableGeoFilters={notificationData.audienceType === 'customer' ? true : false}
                    enableGeoFilters={false}
                    enableLocationFilters={true}
                    defaultLocationFilters= {notificationData.audienceType === 'customer' ? notificationData.customerFilters.locationFilters : notificationData.expertFilters.locationFilters}
                    // defaultLocationFilters={{
                    //     locationFilter: 'radius',
                    //     centerCoordinates: { lat: '', lng: '' },
                    //     radius: '',
                    //     polygon: []
                    // }}
                    audienceType= {notificationData.audienceType === 'customer' ? 'customer' : 'expert'}
                />
                {/* loading states and feedback */}
                {(isLoadingCustomers) ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                        <CircularProgress size={16} />
                        <Typography variant="body2">
                            Applying filters...
                        </Typography>
                    </Box>
                ):
                // (notificationData.customerFilters.filterOptions.length>0 ||  notificationData.expertFilters.filterOptions.length>0 )&&
                    (
                        <Typography variant="subtitle1" sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                        {notificationData.audienceType === 'customer' ? <People fontSize="small" /> : <Engineering fontSize="small" />}
                        Filtered Results: {(isLoadingCustomers || isLoadingExperts) ? <CircularProgress size={16} sx={{ ml: 1 }} /> :notificationData.audienceType === 'customer' ? customerList.length : expertList.length} {notificationData.audienceType}(s)
                    </Typography>
                    )
                }
            </Box>

            
            {/* <Card variant="outlined" sx={{ mb: 2 }}>
                <CardContent sx={{ py: 2 }}>
                    
                </CardContent>
            </Card> */}

            {/* Detailed Selection Component */}
            {notificationData.audienceType === 'customer' ? (
                <CustomerSelection
                    filteredData={customerList}
                    isLoading={isLoadingCustomers}
                    getFullName={getFullName}
                    notificationData={notificationData}
                    setNotificationData={setNotificationData}
                />
            ) : (
                <ExpertSelection
                    filteredData={expertList}
                    isLoading={isLoadingExperts}
                    getFullName={getFullName}
                    notificationData={notificationData}
                    setNotificationData={setNotificationData}
                />
            )}
        </Box>
    );
};

// Customer Selection Component
const CustomerSelection = ({ filteredData, isLoading,getFullName, notificationData, setNotificationData }) => {
    const handleCustomerSelectionChange = (event, newValues) => {
        const hasSelectAll = newValues.some(val => val.id === '__all__');

        if (hasSelectAll) {
            const selectedCustomers = notificationData.customerFilters?.selectedCustomers || [];
            const isAllSelected = selectedCustomers.length === filteredData.length;
            
            if (isAllSelected) {
                setNotificationData(prev => ({
                    ...prev,
                    customerFilters: {
                        ...prev.customerFilters,
                        selectedCustomers: []
                    }
                }));
            } else {
                setNotificationData(prev => ({
                    ...prev,
                    customerFilters: {
                        ...prev.customerFilters,
                        selectedCustomers: filteredData.map(item => ({ id: item.id }))
                    }
                }));
            }
        } else {
            setNotificationData(prev => ({
                ...prev,
                customerFilters: {
                    ...prev.customerFilters,
                    selectedCustomers: newValues.map(item => ({ id: item.id }))
                }
            }));
        }
    };

    const selectedCustomers = notificationData.customerFilters?.selectedCustomers || [];
    const selectedIds = selectedCustomers.map(c => c.id);
    const isAllSelected = filteredData.length > 0 && selectedIds.length === filteredData.length;
    const isIndeterminate = selectedIds.length > 0 && selectedIds.length < filteredData.length;

    const selectAllOption = {
        id: '__all__',
        profile: { firstName: 'Select All Customers' },
    };

    const optionsWithSelectAll = [selectAllOption, ...filteredData];

    return (
        <Card variant="outlined">
            <CardContent>
                <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                    <People fontSize="small" />
                    Select Customers to Notify
                </Typography>
                
                <Autocomplete
                    multiple
                    disableCloseOnSelect
                    options={optionsWithSelectAll}
                    value={selectedCustomers}
                    loading={isLoading}
                    onChange={handleCustomerSelectionChange}
                    getOptionLabel={(option) => {
                        if (option.id === '__all__') return 'Select All Customers';
                        const profile = option.profile || {};
                        return `${getFullName(profile)} (${option.mobileNumber || ''})`;
                    }}
                    isOptionEqualToValue={(option, val) => option.id === val.id}
                    renderOption={(props, option, { selected }) => {
                        if (option.id === '__all__') {
                            return (
                                <li {...props}>
                                    <Checkbox
                                        checked={isAllSelected}
                                        indeterminate={isIndeterminate}
                                        size="small"
                                        sx={{ mr: 1 }}
                                    />
                                    <Typography sx={{ fontSize: '0.8rem', fontWeight: 500 }}>
                                        Select All Customers
                                    </Typography>
                                </li>
                            );
                        }

                        const profile = option.profile || {};
                        const fullName = getFullName(profile);
                        return (
                            <li {...props}>
                                <Checkbox checked={selected} size="small" sx={{ mr: 1 }} />
                                <Box>
                                    <Typography sx={{ fontSize: '0.8rem', fontWeight: 500 }}>
                                        {fullName}
                                        {option.isTester && (
                                            <Box component="span" sx={{
                                                ml: 1,
                                                background: '#ffecb3',
                                                px: 0.5,
                                                borderRadius: '4px',
                                                fontSize: '0.65rem',
                                            }}>
                                                Tester
                                            </Box>
                                        )}
                                        <Box component="span" sx={{ ml: 1, fontSize: '0.7rem', color: '#666' }}>
                                            ({option.mobileNumber})
                                        </Box>
                                    </Typography>
                                    {option.coordinates && (
                                        <Typography sx={{ fontSize: '0.65rem', color: 'text.secondary' }}>
                                            Location: {option.coordinates.lat.toFixed(4)}, {option.coordinates.lng.toFixed(4)}
                                        </Typography>
                                    )}
                                </Box>
                            </li>
                        );
                    }}
                    renderTags={(tagValue, getTagProps) => {
                        const selectedIds = tagValue.map(c => c.id);
                        const allSelected = filteredData.length > 0 && selectedIds.length === filteredData.length;

                        if (allSelected) {
                            return (
                                <Chip
                                    label={`All Customers (${filteredData.length})`}
                                    size="small"
                                    sx={{ fontSize: '0.7rem', height: '24px', mr: 0.5 }}
                                />
                            );
                        }

                        return tagValue.map((option, index) => {
                            const profile = filteredData.find(item => item.id === option.id)?.profile || {};
                            const fullName = getFullName(profile);
                            return (
                                <Chip
                                    label={fullName}
                                    size="small"
                                    {...getTagProps({ index })}
                                    sx={{
                                        fontSize: '0.7rem',
                                        height: '24px',
                                        mr: 0.5
                                    }}
                                />
                            );
                        });
                    }}
                    noOptionsText={<span style={{ fontSize: '0.75rem' }}>No customers found</span>}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            size="small"
                            placeholder="Select customers to notify"
                            InputProps={{
                                ...params.InputProps,
                                style: { fontSize: '0.75rem', color: '#000' },
                                endAdornment: (
                                    <>
                                        {isLoading && <CircularProgress size={16} />}
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                            }}
                        />
                    )}
                />
            </CardContent>
        </Card>
    );
};

// Expert Selection Component
const ExpertSelection = ({ filteredData, isLoading, getFullName, notificationData, setNotificationData }) => {
    const handleExpertSelectionChange = (event, newValues) => {
        const hasSelectAll = newValues.some(val => val.id === '__all__');

        if (hasSelectAll) {
            const selectedExperts = notificationData.expertFilters?.selectedExperts || [];
            const isAllSelected = selectedExperts.length === filteredData.length;
            
            if (isAllSelected) {
                setNotificationData(prev => ({
                    ...prev,
                    expertFilters: {
                        ...prev.expertFilters,
                        selectedExperts: []
                    }
                }));
            } else {
                setNotificationData(prev => ({
                    ...prev,
                    expertFilters: {
                        ...prev.expertFilters,
                        selectedExperts: filteredData.map(item => ({ id: item.id }))
                    }
                }));
            }
        } else {
            setNotificationData(prev => ({
                ...prev,
                expertFilters: {
                    ...prev.expertFilters,
                    selectedExperts: newValues.map(item => ({ id: item.id }))
                }
            }));
        }
    };

    const selectedExperts = notificationData.expertFilters?.selectedExperts || [];
    const selectedIds = selectedExperts.map(e => e.id);
    const isAllSelected = filteredData.length > 0 && selectedIds.length === filteredData.length;
    const isIndeterminate = selectedIds.length > 0 && selectedIds.length < filteredData.length;

    const selectAllOption = {
        id: '__all__',
        profile: { firstName: 'Select All Experts' },
    };

    const optionsWithSelectAll = [selectAllOption, ...filteredData];

    return (
        <Card variant="outlined">
            <CardContent>
                <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Engineering fontSize="small" />
                    Select Experts to Notify
                </Typography>
                
                <Autocomplete
                    multiple
                    disableCloseOnSelect
                    options={optionsWithSelectAll}
                    value={selectedExperts}
                    loading={isLoading}
                    onChange={handleExpertSelectionChange}
                    getOptionLabel={(option) => {
                        if (option.id === '__all__') return 'Select All Experts';
                        const profile = option.UserProfile || {};
                        return `${getFullName(profile)} (${option.mobileNumber || ''})`;
                    }}
                    isOptionEqualToValue={(option, val) => option.id === val.id}
                    renderOption={(props, option, { selected }) => {
                        if (option.id === '__all__') {
                            return (
                                <li {...props}>
                                    <Checkbox
                                        checked={isAllSelected}
                                        indeterminate={isIndeterminate}
                                        size="small"
                                        sx={{ mr: 1 }}
                                    />
                                    <Typography sx={{ fontSize: '0.8rem', fontWeight: 500 }}>
                                        Select All Experts
                                    </Typography>
                                </li>
                            );
                        }

                        const profile = option.UserProfile || {};
                        const fullName = getFullName(profile);
                        return (
                            <li {...props}>
                                <Checkbox checked={selected} size="small" sx={{ mr: 1 }} />
                                <Box>
                                    <Typography sx={{ fontSize: '0.8rem', fontWeight: 500 }}>
                                        {fullName}
                                        {/* <Box component="span" sx={{ ml: 1, fontSize: '0.7rem', color: 'primary.main', fontWeight: 600 }}>
                                            {option.specialty}
                                        </Box> */}
                                        <Box component="span" sx={{ ml: 1, fontSize: '0.7rem', color: '#666' }}>
                                            ({option.mobileNumber})
                                        </Box>
                                    </Typography>
                                    <Typography sx={{ fontSize: '0.65rem', color: 'text.secondary' }}>
                                        {/* Coverage: {option.coverageArea}
                                        {option.coordinates && (
                                            <Box component="span" sx={{ ml: 1 }}>
                                                | Location: {option.coordinates.lat.toFixed(4)}, {option.coordinates.lng.toFixed(4)}
                                            </Box>
                                        )} */}
                                    </Typography>
                                </Box>
                            </li>
                        );
                    }}
                    renderTags={(tagValue, getTagProps) => {
                        const selectedIds = tagValue.map(e => e.id);
                        const allSelected = filteredData.length > 0 && selectedIds.length === filteredData.length;

                        if (allSelected) {
                            return (
                                <Chip
                                    label={`All Experts (${filteredData.length})`}
                                    size="small"
                                    sx={{ fontSize: '0.7rem', height: '24px', mr: 0.5 }}
                                />
                            );
                        }

                        return tagValue.map((option, index) => {
                            const profile = filteredData.find(item => item.id === option.id)?.UserProfile || {};
                            const fullName = getFullName(profile);
                            return (
                                <Chip
                                    label={fullName}
                                    size="small"
                                    {...getTagProps({ index })}
                                    sx={{
                                        fontSize: '0.7rem',
                                        height: '24px',
                                        mr: 0.5
                                    }}
                                />
                            );
                        });
                    }}
                    noOptionsText={<span style={{ fontSize: '0.75rem' }}>No experts found</span>}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            size="small"
                            placeholder="Select experts to notify"
                            InputProps={{
                                ...params.InputProps,
                                style: { fontSize: '0.75rem', color: '#000' },
                                endAdornment: (
                                    <>
                                        {isLoading && <CircularProgress size={16} />}
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                            }}
                        />
                    )}
                />
            </CardContent>
        </Card>
    );
};

export default FilterSection;